export const KANBAN_COLS = ["Aberto", "Em tratamento", "Resolvido", "Concluído"];

export const STATUS_COLORS = {
  "Aberto": "#2563eb",
  "Em tratamento": "#7c3aed",
  "Resolvido": "#059669",
  "Concluído": "#6b7280",
};

export const isAutoArchived = (t) => {
  if (t.status !== "Concluído") return false;
  const closedDate = t.closedAt || t.created;
  const cutoff = new Date(); cutoff.setDate(cutoff.getDate() - 30);
  return new Date(closedDate) < cutoff;
};

export const PRIORITY_COLORS = { Alta: "#ef4444", Média: "#f59e0b", Baixa: "#22c55e" };
export const PRIORITY_BG    = { Alta: "#fef2f2",  Média: "#fffbeb", Baixa: "#f0fdf4" };
export const PRIORITY_TEXT  = { Alta: "#dc2626",  Média: "#d97706", Baixa: "#16a34a" };

export const DOC_CATS = ["Atas", "Regulamentos", "Contratos", "Seguros", "Outros"];

// ─── Orçamento: categorias de receita ────────────────────────────────────────
export const REVENUE_CATEGORIES = [
  { key: "arrendamento",     label: "Arrendamento de espaço",   color: "#0d9488", bg: "#ccfbf1" },
  { key: "extraordinarias",  label: "Receitas Extraordinárias", color: "#0d9488", bg: "#ccfbf1" },
  { key: "outros_receita",   label: "Outros",                   color: "#0d9488", bg: "#ccfbf1" },
];

// Destinos de uma receita (a percentagem de cada é definida por rubrica).
export const REVENUE_DESTINATIONS = {
  fundo:  "Fundo de Reserva",
  alivio: "Despesas Correntes",
};

// Categoria de exibição para as quotas extra dentro das Despesas do orçamento.
// Não aparece no dropdown de "Adicionar Rubrica"; é gerida na tab Quotas.
export const EXTRA_QUOTA_CATEGORY = { key: "quota_extra", label: "Quotas Extra", color: "#dc2626", bg: "#fee2e2" };

/**
 * Calcula os totais de um orçamento a partir das rubricas.
 * Cada receita reparte-se por percentagem entre:
 * - alivio (Despesas Correntes): abate à quota dos condóminos
 * - fundo  (Fundo de Reserva):   não altera a quota
 * As despesas marcadas como quota extra (isExtraQuota) são cobradas em separado
 * (por permilagem) e ficam de fora do valor a cobrir regular.
 */
export const computeBudgetTotals = (items = [], opts = {}) => {
  const { openingReserve = 0, reserveUsePct = 0 } = opts;
  let despesas = 0, quotasExtra = 0, receitasAlivio = 0, receitasFundo = 0;
  for (const i of items) {
    const amt = i.amount || 0;
    if (i.type === "receita") {
      const ap = (i.alivioPct != null
        ? i.alivioPct
        : (i.revenueDestination === "alivio" ? 100 : 0)) / 100;
      receitasAlivio += amt * ap;
      receitasFundo  += amt * (1 - ap);
    } else if (i.isExtraQuota) {
      quotasExtra += amt;
    } else {
      despesas += amt;
    }
  }
  // Parte do fundo de reserva aplicada às despesas correntes (reduz a quota).
  const reserveUsed = Math.max(0, Math.min(openingReserve, openingReserve * (reserveUsePct / 100)));
  return {
    despesas,                              // despesas correntes (exclui quotas extra)
    quotasExtra,
    despesasTotal: despesas + quotasExtra, // todas as despesas do orçamento
    receitasAlivio,
    receitasFundo,
    receitas: receitasAlivio + receitasFundo,
    reserveUsed,
    valorACobrir: Math.max(0, despesas - receitasAlivio - reserveUsed),
  };
};

export const DEMO_CONDO_NAME = "Condomínio Demo — Edifício Solar";

// Enquanto o módulo de Definições/pagamentos está em desenvolvimento, mantém-se
// bloqueado. Colocar a true reativa o menu Definições e os avisos do PayPal.
export const SETTINGS_ENABLED = false;
